import script from "./Gartenkultur-Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Inbox.vue?vue&type=style&index=0&id=48a20a2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a20a2a"]])

export default __exports__